interface FlagProps {
  className?: string;
}

export function IraqFlag({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 900 600" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#CE1126" width="900" height="200"/>
      <rect fill="#FFFFFF" y="200" width="900" height="200"/>
      <rect fill="#000000" y="400" width="900" height="200"/>
      <text x="450" y="340" fill="#007A3D" fontSize="120" fontFamily="serif" textAnchor="middle" fontWeight="bold">الله أكبر</text>
    </svg>
  );
}

export function ChinaFlag({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 900 600" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#DE2910" width="900" height="600"/>
      <g fill="#FFDE00">
        <polygon points="150,75 168,123 120,96 180,96 132,123"/>
        <polygon points="230,30 240,55 215,42 255,42 230,55" transform="rotate(23 240 42)"/>
        <polygon points="260,65 270,90 245,77 285,77 260,90" transform="rotate(46 270 77)"/>
        <polygon points="260,115 270,140 245,127 285,127 260,140" transform="rotate(70 270 127)"/>
        <polygon points="230,150 240,175 215,162 255,162 230,175" transform="rotate(20 240 162)"/>
      </g>
    </svg>
  );
}

export function TurkeyFlag({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 900 600" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <rect fill="#E30A17" width="900" height="600"/>
      <circle fill="#FFFFFF" cx="300" cy="300" r="150"/>
      <circle fill="#E30A17" cx="345" cy="300" r="120"/>
      <polygon fill="#FFFFFF" points="495,300 560,330 520,285 520,315 560,270" transform="rotate(18 520 300)"/>
    </svg>
  );
}
